import './User.scss'

import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useToaster } from "../../../contexts/Toaster"
import { useModal } from '../../../contexts/Modal'
import { Roles } from '../../../utilities/constants'
import { useCharacters } from '../../../contexts/Characters'
import koalition from '../../../api/koalition'
import Tooltip from '../../core/Tooltip/Tooltip'
import EditUser from '../../modals/EditUser/EditUser'

const User = ({}) => {
    const toaster = useToaster()
    const modal = useModal()
    const characters = useCharacters()
    const { userId } = useParams()
    const navigate = useNavigate()
    const [user, setUser] = useState()

    const loadUser = () => {
        koalition.get(`/users/${userId}`).then((response) => {
            setUser(response.data)
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const onCharacterClick = (characterId) => {
        navigate(`/characters/${characterId}`)
    }

    const onUserEditClick = () => {
        modal.open({ title: 'Edit User', component: <EditUser />, data: { user, loadUser } })
    }

    const onUserLoginClick = () => {
        koalition.get(`/users/${user._id}/jwt`).then((response) => {
            localStorage.setItem('jwt', response.data)
            window.location.reload()
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    useEffect(() => {
        loadUser()
    }, [userId])

    return (
        <div className="container-fluid user-profile">
            {user && (
                <div>
                    <header className="row">
                        <h1 className="col id">User {user._id}</h1>
                        <div className="col-auto ml-auto">
                            <Tooltip text="Edit User" align="right">
                                <button className="primary medium icon" onClick={onUserEditClick}>
                                    <img src="/images/icons/pencil.svg" />
                                </button>
                            </Tooltip>

                            {characters.authorized([Roles.developer]) && (
                                <Tooltip text="Login" align="right">
                                    <button className="primary medium icon ml-3" onClick={onUserLoginClick}>
                                        <img src="/images/icons/lock_open.svg" />
                                    </button>
                                </Tooltip>
                            )}
                        </div>
                    </header>
                
                    <main>
                        <section className="general-infos mt-4">
                            <div className="card">
                                <ul>
                                    <li className="mt-2"><b>Email: </b>{user.email}</li>
                                    <li className="mt-2"><b>Discord Id: </b>{user.discordId}</li>
                                </ul>
                            </div>
                        </section>

                        <section className="characters mt-4">
                            <ul className="row pr-4">
                                {user.characters.map((character) => (
                                    <li className="col-6 col-md-4 col-lg-3 col-xl-2 pr-0" key={character.id}>
                                        <div className="card character flex-center-y justify-content-between cursor-pointer mb-4" onClick={() => onCharacterClick(character._id)}>
                                            {character.alliance && <span className="chip base aliance mr-3">{character.alliance?.tag}</span>}
                                            <span className="mr-auto">{character.name}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </section>
                    </main>
                </div>
            )}
        </div>
    )
}

export default User